import { CSSProperties, useEffect, useState } from 'react';
import { Color, Size } from '@vivli/shared/theme';
import { GoBackLinkComponent } from '@vivli/shared/components';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { useOrganizationDetailsContext } from '@vivli/features/organizations/infrastructure/context';
import { useFormContext, useFormState } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { AdminHeaderButtonView, AdminHeaderTitleView, ButtonView } from '@vivli/shared/views';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { useActiveUserContext, useModalApiContext } from '@vivli/core/infrastructure/context';
import { useFormDirtyTracking } from '@vivli/shared/infrastructure/hook';

const buttonStyle: CSSProperties = {
    marginLeft: Size.PADDING,
    marginRight: Size.PADDING,
    border: `1px solid ${Color.VIVLI_BLUE}`,
    backgroundColor: Color.TRANSPARENT,
    color: Color.VIVLI_BLUE
};

const headerDisplayStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: Size.HALF_PADDING
};

const buttonsStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end'
};
interface OrgAdminHeaderComponentProps {
    isMemberTab: boolean;
}

export const OrgAdminHeaderComponent = ({ isMemberTab }: OrgAdminHeaderComponentProps) => {
    const { hasPermission } = useActiveUserContext();
    const isVivliAdmin = hasPermission(PermissionsEnum.CreateOrg);
    const modalService = useModalApiContext();
    const navigate = useNavigate();
    const formApi = useFormContext<IOrganization>();
    const { organization, handleSave, isSaving, showAddMemberPopup, hasMemberChanges } = useOrganizationDetailsContext();
    const { isValid } = useFormState({ control: formApi.control });
    const isFormDirty = useFormDirtyTracking(formApi);

    const [adminHeaderTitle, setAdminHeaderTitle] = useState<string>(organization?.name);

    const handleClick = () => {
        modalService.confirm('Do you want to discard your changes?', {
            title: 'Cancel',
            onConfirm: () => navigate('/admin/orgs/')
        });
    };

    useEffect(() => {
        if (organization?.id) {
            setAdminHeaderTitle(organization?.name || organization?.emailDomain);
        } else {
            setAdminHeaderTitle('Add New Organization');
        }
    }, [organization]);

    return (
        <div>
            <div style={headerDisplayStyle}>
                <div>{isVivliAdmin && <GoBackLinkComponent destination={'/admin/orgs'} />}</div>
                <div style={buttonsStyle}>
                    {isMemberTab && isVivliAdmin && (
                        <ButtonView
                            style={{ ...buttonStyle, marginRight: 0 }}
                            title="Add Member"
                            disabled={isSaving}
                            onClick={showAddMemberPopup}
                            className="orgDetails_cancel"
                        >
                            <FontAwesomeIcon icon={faCirclePlus} style={{ marginRight: 5 }} />
                            Add Member
                        </ButtonView>
                    )}

                    <ButtonView style={buttonStyle} title="Cancel" disabled={isSaving} onClick={handleClick} className="orgDetails_cancel">
                        Cancel
                    </ButtonView>

                    <AdminHeaderButtonView
                        title="Save"
                        onClick={formApi.handleSubmit(handleSave)}
                        isLoading={isSaving}
                        isDisabled={(!isFormDirty && !hasMemberChanges) || !isValid || isSaving}
                    />
                </div>
            </div>
            <div style={{ marginBottom: 10 }}>
                <AdminHeaderTitleView title={adminHeaderTitle} />
            </div>
        </div>
    );
};
